var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBnb1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n\t.st1{fill:#F4BB0B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493,250c0,134.2-108.8,243-243,243C115.8,493,7,384.2,7,250C7,115.8,115.8,7,250,7C384.2,7,493,115.8,493,250 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250,297.7L202.3,250l47.7-47.7l47.7,47.7L250,297.7z M358.4,250l-0.2,0.2l44.2,44.2l44.4-44.4l-44.7-44.7 l-44.2,44.2L358.4,250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.4,218.3l76.6-76.6l77.8,77.8l44.2-44.2l-122-122L129.1,174L173.4,218.3z M328.1,280.3L250,358.4 L172.6,281l-44.2,44.2L250,446.8l122.3-122.3L328.1,280.3z M141.6,250l1.6-1.6L99,204.1L53.2,250l45.1,45.1l44.2-44.2L141.6,250z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBnb1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BNB1.e7ff972d167cb88cbbe83643ced07cb0.svg";